export const ORGANISATIONS_FETCH_REQUEST = 'organisations_fetch_request';
export const ORGANISATIONS_FETCH_SUCCESS = 'organisations_fetch_success';
export const ORGANISATIONS_FETCH_FAILURE = 'organisations_fetch_faliure';
